export var HubChannel;
(function(HubChannel) {
    HubChannel["NOTIFICATIONS"] = "eclipsenotifications";
    HubChannel["NEW_FEEDBACK"] = "mcfeedbacknew";
    HubChannel["DREAMSOFART"] = "dreamsofart";
    HubChannel["CHATUNREAD"] = "chatunread";
    HubChannel["BATCH_COMPLETE"] = "batchcomplete";
})(HubChannel || (HubChannel = {}));
